import { skipToken, useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { ExtractBody, ExtractKey, QueryOptions } from "typings/query";

export function useRiskRangesQuery<T = Body>({
  metricNames,
  options = {},
}: {
  metricNames: string[] | undefined;
  options?: QueryOptions<Body, Key, T>;
}) {
  const apiClient = useAPIClient();

  return useQuery({
    queryKey: queryKey(metricNames),
    queryFn: metricNames?.length ? queryFn(apiClient, metricNames) : skipToken,
    staleTime: Infinity,
    ...options,
  });
}

const queryKey = (metricNames: string[] | undefined) => [
  "risk-ranges",
  metricNames,
];

const queryFn = (apiClient: APIClient, metricNames: string[]) => async () => {
  const dto = await apiClient.riskRange.getBatchRiskRanges({
    metricNames,
  }).result;
  return dto.results;
};

type Body = ExtractBody<typeof queryFn>;
type Key = ExtractKey<typeof queryKey>;
